import styles from "./Main.module.css";
import BottomSlideBar from "../BottomSlideBar/BottomSlideBar";
import MainContent from "../MainContent/MainContent";
import cld from "../../cloudinary";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { useSelector } from "react-redux";

export default function Main() {
  const menuBarToggle = useSelector((state) => state.menuBarToggle);
  const activeCelebData = useSelector((state) => state.activeCelebData);
  const activeImage = useSelector((state) => state.activeImage);
  const img_url = cld
    .image(activeCelebData[activeImage].public_id)
    .resize(fill(1900, 1080).gravity("faces"))
    .toURL();

  return (
    <>
      <div
        className={`${styles.main} ${menuBarToggle ? styles.active : null}`}
        style={{
          backgroundImage: `radial-gradient( rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100% ), url('${img_url}')`,
        }}
      >
        <MainContent />
        <BottomSlideBar />
      </div>
    </>
  );
}
